export class Settings {
    public static readonly showUserAnswers:SettingsString = "showUserAnswers";
}

export type SettingsString = "showUserAnswers";